import React, {useContext} from 'react';
import "./Contact.scss";
import {ContactContext} from "../../../contexts/Contact";
import SettingsContext from "../../../contexts/Settings";
import {Text} from "../../Text";
import HomeSectionTitle from "../../HomeSectionTitle";

const Contact = () => {

	const {
		notka,
		osoby_kontaktowe,
		tytul,
		designed_by
	} = useContext(ContactContext);

	const {settingsData} = useContext(SettingsContext);
	const { loga, social_media } = settingsData;

	return (
		<div className="contact">
			<div className="row contact__top">
				<div className="col col-xs-12">
					<HomeSectionTitle text={tytul}/>
				</div>
			</div>
			<div className="row contact__middle">
				<div className="col col-xs-12 col-md-6"/>
				<div className="col col-xs-12 col-md-6">
					<ul title="contact people">
						{osoby_kontaktowe?.map( osoba =>
							<li key={osoba.email}>
								<div className="row">
									<div className="col col-xs-12 col-md-6">
										<p>
											<span>{osoba.stanowisko}</span>
											{osoba.imie_i_nazwisko}
										</p>
									</div>
									<div className="col col-xs-12 col-md-6">
										<p>
											<Text code="email" tag="span"/>
											{osoba.email}
										</p>
									</div>
								</div>
							</li>
						)}
					</ul>

				</div>
			</div>
			<div className="row contact__bottom">
				<div className="col col-xs-12 col-md-5">
					<div className="row">
						<div className="col col-xs-2 contact__bottom__logo">
							<img src={loga?.logo_footer} alt="Logo Film Poland"/>
						</div>
						<div className="col col-xs-10 contact__bottom__note">
							<span>{notka}</span>
						</div>
					</div>
				</div>
				<div className="col col-xs-12 col-md-1"/>
				<div className="col col-xs-12 col-md-6">
					{social_media.length>0 &&
						<ul className="contact__bottom__socials" title="Social media">
							{social_media?.map( item =>
								<li key={item.social_link}>
									<a href={item.social_link} target="_blank" rel="noopener noreferrer" >
										{item.social_etykieta}
									</a>
								</li>
							)}
						</ul>
					}
				</div>
			</div>
			<div className="row contact__glossary">
				<div className="col col-xs-12">
					{designed_by && <p dangerouslySetInnerHTML={{__html:designed_by}}/>}
				</div>
			</div>

		</div>
	);
};

export default Contact;